import { render, staticRenderFns } from "./more-option.vue?vue&type=template&id=3f421a5c&scoped=true"
import script from "./more-option.vue?vue&type=script&lang=js"
export * from "./more-option.vue?vue&type=script&lang=js"
import style0 from "./more-option.vue?vue&type=style&index=0&id=3f421a5c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f421a5c",
  null
  
)

export default component.exports